import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class FavoriteApi {

    static all() {
        return HTTP.get(config.favoriteApi.favorite)
            .then(response => response.data)
    }

    static delete(id) {
        return HTTP.delete(`${config.favoriteApi.favorite}/${id}`)
            .then(response => response.data);
    }

    static add(favorite) {
        return HTTP.post(config.favoriteApi.favorite, favorite)
            .then(response => response.data)
    }


}